// extracted by mini-css-extract-plugin
export var active = "_cx-c";
export var compactArrow = "_cx-5";
export var container = "_cx-0";
export var dot = "_cx-b";
export var dotContainer = "_cx-a";
export var hoverArrowButton = "_cx-7";
export var hoverArrowContainer = "_cx-6";
export var leftHoverArrowContainer = "_cx-8 _cx-6";
export var rightHoverArrowContainer = "_cx-9 _cx-6";
export var slide = "_cx-4";
export var sliderContainer = "_cx-1";
export var sliderContainerVisibleOverflow = "_cx-2";
export var sliderOverflow = "_cx-3";
export var vignetteBoth = "_cx-f";
export var vignetteLeft = "_cx-e";
export var vignetteRight = "_cx-d";